export const REGISTRATION_STEPS = ['Informations', 'Qualifications', 'Documents', 'Confirmation'] as const;

export const CONTRACT_TYPES = [
  { label: 'CDI', value: 'cdi' },
  { label: 'CDD', value: 'cdd' },
  { label: 'Intérim', value: 'interim' },
  { label: 'Freelance', value: 'freelance' },
  { label: 'Stage', value: 'stage' },
  { label: 'Alternance', value: 'alternance' },
] as const;


export const FRENCH_REGIONS = [
  'Auvergne-Rhône-Alpes',
  'Bourgogne-Franche-Comté',
  'Bretagne',
  'Centre-Val de Loire',
  'Corse',
  'Grand Est',
  'Hauts-de-France',
  'Île-de-France',
  'Normandie',
  'Nouvelle-Aquitaine',
  'Occitanie',
  'Pays de la Loire',
  "Provence-Alpes-Côte d'Azur",
  'Guadeloupe',
  'Guyane',
  'La Réunion',
  'Martinique',
  'Mayotte'
] as const;

export const DRIVER_LICENSES = [
  'Permis A',
  'Permis B',
  'Permis C',
  'Permis D',
  'Permis E',
  'Aucun'
] as const;

export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpeg',
  'image/jpg'
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const PASSWORD_MIN_LENGTH = 8;